<template>
    <div class="body-view-week">
        <!-- 周标识 -->
        <div class="items-week">
            <div class="left-none">{{ weekCycleStr }}</div>

            <div class="item-week"
                 v-for="(weekItem, weekIndex) in weekItems" :key="weekIndex">
                周{{ weekItem }}
            </div>
        </div>

        <!-- 全天 -->
        <div class="row-week-day">
            <div class="left-day">全天</div>
            <div class="item-all-day my-cursor"
                 :style="{'background': selectDayStr === dayItem.date ? 'rgba(255, 239, 180, 0.4)': ''}"
                 @click.stop="submitDay(dayItem)"
                 v-for="(dayItem) in dayItems">
                <div class="item-day-title">
                    <div class="text-day"
                         :style="[
                                {'background': selectDayStr === dayItem.date ? '#F7C2C7': ''},
                                {'border-color': dayItem.isToday ? '#F7C2C7': ''}
                            ]">
                        <template v-if="dayItem.isToday">
                            今
                        </template>
                        <template v-else>
                            {{ dayItem.day }}
                        </template>
                    </div>
                    <div class="text-vice-day" :style="[{'color': dayItem.viceColor}]">{{ dayItem.viceDay }}</div>
                    <div class="text-work-day " v-if="dayItem.isWork === 1">班</div>
                    <div class="text-rest-day" v-else-if="dayItem.isWork === 2">休</div>
                </div>
            </div>
        </div>
        <!-- 横向链表 -->
        <div class="row-item-matter">
            <div class="chain-row"
                 v-for="(chainItem) in allDayChainItems">
                <div class="item-matter"
                     :style="[
                         {width: 'calc((100% / 7) * '+ (1+ matterItem.endDayIndex - matterItem.startDayIndex) +')'},
                         {marginLeft: 'calc((100% / 7) * '+ matterItem.leftNum +')'}
                     ]"
                     v-for="(matterItem) in chainItem">

                    <div class="text-matter my-cursor"
                         :style="[{'background': matterItem.color},{'opacity': (matterItem.state === 1 || matterItem.state === 2) ? 0.25:1}]"
                         @click.stop="submitMatter(matterItem)">
                        {{ matterItem.text}}
                    </div>
                </div>
            </div>
        </div>
        <!-- 滚动显示 -->
        <div class="row-scroll" ref="row-scroll">
            <!-- 时间点、时间段 -->
            <!-- 上 折叠行 -->
            <div class="row-up-fold-hour" v-if="upFoldIndex > -1">
                <div class="left-hour my-cursor" @click.stop="setUnfoldIndex('upFoldIndex')">
                    00:00<br>
                    <i class="el-icon-arrow-up"></i><br>
                    <i class="el-icon-arrow-down"></i><br>
                    {{hourItems[0].hour}}:00
                </div>
                <!-- 折叠事项 -->
                <div class="item-hour-day" v-for="(hourDayChainItem) in hourDayChainItems">
                    <div class="fold-matter-text"
                         v-if="unFoldItemIndex < 3"
                         v-for="(upFoldItem, unFoldItemIndex) in hourDayChainItem.upFoldItems">
                        {{upFoldItem.title}} {{upFoldItem.time}}
                    </div>
                    <div class="fold-more-text" v-if="hourDayChainItem.upFoldItems.length > 3">
                        +{{ hourDayChainItem.upFoldItems.length - 3 }}
                    </div>
                </div>
            </div>
            <!-- 展示行 -->
            <div class="row-hour-item" v-for="(hourItem) in hourItems">

                <div class="left-hour"
                     :class="{'my-cursor': hourItem.foldAllow}"
                     @mouseover="mouseenter(hourItem.index)" @mouseleave="mouseleave()"
                     @click.stop="setFoldIndex(hourItem.index, hourItem.foldAllow)">
                    <div class="hour-text">
                        {{ hourItem.hour }}:00
                    </div>
                    <!-- 折叠
                        1. 0至十点;
                        2. 14至24点2鼠标划入
                    -->
                    <template v-if="hourItem.foldAllow && mouseHourIndex === hourItem.index">
                        <div class="fold-switch">
                            <i class="el-icon-arrow-down"></i><br>
                            <i class="el-icon-arrow-up"></i>
                        </div>
                    </template>

                </div>
                <div class="item-hour-day" v-for="(dayItem,dayIndex) in dayItems">
                    <div class="time-line" :style="[
                            {background: dayItem.isToday? 'rgba(225, 62, 57, 1)': 'rgba(225, 62, 57, 0.2)'},
                            {marginTop: (minuteNumber * 2.358 / 100) + 'rem'}]"
                         v-if="hourItem.index === hourNumber">
                        <div class="time-line-point" v-if="dayItem.isToday"></div>
                        <div class="hour-text-now" v-if="dayIndex === 0"
                             :style="{marginLeft: dayIndex === 0 && dayItem.isToday? '-0.6rem': '-0.5rem'}">
                            {{ lineTime }}
                        </div>
                    </div>
                </div>
            </div>
            <!-- 纵向链表 -->
            <!-- 总高度 3720 - 上折叠 -下折叠 / 100 .rem -->
            <div class="column-items-day"
                 :style="[
                         {height: (3720 - (upFoldIndex+1) * 155 - (24 - downFoldIndex) * 155) / 100 + 'rem'},
                         {marginTop: -(3720 - (upFoldIndex+1) * 155 - (24 - downFoldIndex) * 155) / 100 + 'rem'},
                         ]"
            >
                <div class="column-item-day" v-for="(hourDayChainItem) in hourDayChainItems">

                    <div class="column-chain-item"
                         :style="{width: 'calc(100% / ' + hourDayChainItem.chainItems.length +')'}"
                         v-for="(chainItem) in hourDayChainItem.chainItems">

                        <div class="matter-item"
                             :style="[
                                     {width: matterItem.freeWidth * 100 + '%'},
                                     {height: (matterItem.endHeight - matterItem.startHeight) / 100 + 'rem'},
                                     {marginTop: matterItem.topHeight/100 + 'rem'}]"
                             v-for="(matterItem) in chainItem.chainMatter">
                            <div class="matter-text my-cursor" :style="[
                                    {'background': matterItem.color},
                                    {'opacity': matterItem.state === 1 || matterItem.state === 2 ? 0.25:1}
                                ]" @click.stop="submitMatter(matterItem)">
                                {{ matterItem.text }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 下 折叠行 -->
            <div class="row-down-fold-hour" v-if="downFoldIndex < 24">
                <div class="left-hour my-cursor" @click.stop="setUnfoldIndex('downFoldIndex')">
                    {{ parseInt(hourItems[hourItems.length - 1].hour) + 1 }}:00<br>
                    <i class="el-icon-arrow-up"></i><br>
                    <i class="el-icon-arrow-down"></i><br>
                    24:00
                </div>
                <div class="item-hour-day" v-for="(hourDayChainItem) in hourDayChainItems">
                    <div class="fold-matter-text"
                         v-if="downFoldItemIndex < 3"
                         v-for="(downFoldItem, downFoldItemIndex) in hourDayChainItem.downFoldItems">
                        {{downFoldItem.title}} {{downFoldItem.time}}
                    </div>
                    <div class="fold-more-text" v-if="hourDayChainItem.downFoldItems.length > 3">
                        +{{ hourDayChainItem.downFoldItems.length - 3 }}
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import listShowInfo from "@/utils/List/listShowInfo";
import SetChainItems from "@/utils/View/SetChainItems";
import SetChainItemsHour from "@/utils/View/SetChainItemsHour";
export default {
    name: "index",
    data(){
        return {
            weekItems: ["一", "二", "三", "四", "五", "六", "日"], // 周标识
            weekCycleStr: "",
            dayItems: [],
            selectDayStr: "",
            hourItems: [], // 小时对象
            allDayChainItems: [], // 全天类 链表数据
            hourDayChainItems: [], // 小时类 链表数据
            upFoldIndex: -1,
            downFoldIndex: 24,
            mouseHourIndex: -1,
            todayStr: "",
            lineTime: "",
            hourNumber: 0,
            minuteNumber: 0,
            intervalId: null,
        }
    },
    methods: {
        /**
         * 更新阳历周对象
         */
        getCycleDayItems: function(weekType){
            //
            if(weekType === "prev"){
                this.solarWeek = this.solarWeek.next(-1)
            }else if(weekType === "next"){
                this.solarWeek = this.solarWeek.next(1);
            }else if(weekType === "current"){
                this.solarWeek = SolarWeek.fromDate(new Date(), 1);
            }
            this.selectDayStr = "";
            // 更新周期内事件
            this.updateMatterItem();
        },
        updateMatterItem: function(){
            let dayItems = this.solarWeek.getDays();
            let cycleFirstDay = dayItems[0];
            const cycleLastDay = dayItems[6];
            dayItems.forEach((item,index,array)=>{
                const itemYmd = item.toYmd();
                const isWork = this.$Utils.checkWork(itemYmd);
                const isToday = itemYmd === this.todayStr;
                if(isToday && this.selectDayStr === ""){
                    this.selectDayStr = itemYmd;
                }
                const viceItem = this.$Utils.getViceDay(item);
                array[index] = {
                    day: item.getDay(),
                    viceDay: viceItem.viceDay,
                    viceColor: viceItem.viceColor,
                    isWork: isWork,
                    weekday: item.getWeekInChinese(),
                    isToday: isToday,
                    date: itemYmd,
                    matterArray: [],
                }
            });

            // 获取每一天的清单
            listShowInfo.setMonthDays(dayItems);
            this.dayItems = dayItems;

            // 将当月的天数划分为每7天一个单位，作展示链
            this.setChainArray();
            // 标题日期
            const titleDate = cycleFirstDay.getYear() + "年" + this.$Utils.addZero(cycleFirstDay.getMonth()) + "月";
            // 周期范围
            this.weekCycleStr = cycleFirstDay.getMonth() + "." + cycleFirstDay.getDay() + "-"
                + cycleLastDay.getMonth() + "." + cycleLastDay.getDay()
            cycleFirstDay = cycleFirstDay.toYmd();
            // 周期第一天
            if(this.selectDayStr === ""){
                this.selectDayStr = cycleFirstDay;
            }
            this.submitCycle(titleDate, cycleFirstDay);
        },
        setChainArray: function(){

            this.allDayChainItems = SetChainItems.setChainItems(this.dayItems, 2, "week");
            // 小时
            const hourDayChainItems = [];
            for (let i=0; i < 7; i++){
                hourDayChainItems.push({
                    chainItems:[],
                    upFoldItems: [],
                    downFoldItems: [],
                    dayIndex: i,
                })
            }

            this.hourDayChainItems = SetChainItemsHour.setChainItems(this.dayItems, hourDayChainItems, this.upFoldIndex, this.downFoldIndex);
            this.hourItems = this.$Utils.getHourItems(this.upFoldIndex, this.downFoldIndex);
        },
        toTimeHeight: function(){
            setTimeout(()=>{
                const rowScroll = this.$refs["row-scroll"];
                rowScroll.scrollTo({
                    top: (this.hourNumber - 2) * 155  * (width_scale / 100),
                    behavior: "smooth",
                });
            }, 500)
        },
        /**
         * 鼠标 移入小时
         */
        mouseenter: function(hourIndex){
            this.mouseHourIndex = hourIndex;
        },
        /**
         * 鼠标 移出小时
         */
        mouseleave: function(){
            this.mouseHourIndex = -1;
        },
        /**
         * 点击折叠
         * 1. 显示折叠行
         * 2. 重新计算数据
         * @param hourIndex
         * @param foldAllow
         */
        setFoldIndex: function(hourIndex, foldAllow){
            if(!foldAllow){
                return
            }else if(hourIndex < 10){
                // 向上折叠 0至hourIndex
                this.upFoldIndex = hourIndex;
                const rowScroll = this.$refs["row-scroll"];
                rowScroll.scrollTo({
                    top: 0,
                    behavior: "smooth",
                });
            }else if(hourIndex > 13){
                // 向下折叠 hourIndex 至 24点
                this.downFoldIndex = hourIndex;
            }else{
                return
            }
            this.getChainItems(this.dayItems);
        },
        getRedLine:function(){
            const now = new Date();
            this.todayStr = Solar.fromDate(now).toYmd();
            const hour = now.getHours();
            const minute = now.getMinutes();
            this.lineTime = this.$Utils.addZero(hour) + ":" + this.$Utils.addZero(minute);
            this.hourNumber = hour;
            this.minuteNumber = minute;
        },

        /**
         * 点击展开
         * @param foldType
         */
        setUnfoldIndex: function(foldType){

            if(foldType === "upFoldIndex"){
                this.upFoldIndex = -1;
            }else{
                this.downFoldIndex = 24;
            }
            this.getChainItems(this.dayItems);
        },
        submitCycle: function(titleDate, cycleFirstDay){
            this.$emit("cycleEvent", {
                titleDate: titleDate,
                cycleFirstDay: cycleFirstDay,
                selectDayStr: this.selectDayStr,
            });
        },
        submitDay: function(dayItem){
            this.selectDayStr = dayItem.date;
            this.$emit("dayEvent", dayItem);
        },
        submitMatter: function(matterItem){
            if(matterItem.matterItem){
                this.$emit("matterEvent", matterItem.matterItem);
            }else{
                this.submitDay(this.dayItems[matterItem.startDayIndex]);
            }
        },
    },
    mounted(){
        // 获取当前时间
        this.getRedLine();

        this.intervalId = setInterval(()=>{
            this.getRedLine()
        }, 5000);

        this.getCycleDayItems("current");
        this.toTimeHeight();
    },
    beforeDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }
}
</script>

<style scoped>
div.body-view-week{
    width: 100%;
    height: calc(100% - 0.56rem);
}
div.items-week{
    width: 100%;
    height: 0.46rem;
    display: flex;
    border-top: rgba(0, 0, 0, 0.1) solid 0.01rem;
    border-bottom: rgba(0, 0, 0, 0.1) solid 0.01rem;
    box-sizing: border-box;
}

div.left-none{
    width: 0.8rem;
    height: 0.44rem;
    font-size: 0.12rem;
    font-family: PF-Regular, sans-serif;
    color: #333333;
    line-height: 0.44rem;
    text-align: center;
}

div.item-week{
    flex: 1;
    font-size: 0.15rem;
    font-family: PF-Regular, sans-serif;
    color: #333333;
    line-height: 0.44rem;
    text-indent: 0.16rem;
    box-sizing: border-box;
    border-left: rgba(0, 0, 0, 0.1) solid 0.01rem;
}

div.row-week-day{
    width: 100%;
    height: 0.9rem;
    display: flex;
    box-sizing: border-box;
    border-bottom: rgba(0, 0, 0, 0.1) solid 0.01rem;
}
div.left-day{
    flex-basis: 0.8rem;
    font-size: 0.16rem;
    font-family: PF-Regular, sans-serif;
    color: #333333;
    line-height: 0.9rem;
    text-align: center;
}
div.item-all-day{
    flex: 1;
    box-sizing: border-box;
    border-left: rgba(0, 0, 0, 0.1) solid 0.01rem;
}
div.item-all-day:hover{
    background: rgba(255, 239, 180, 0.2);
}
div.item-day-title{
    width: 100%;
    height: 0.34rem;
    display: flex;
    align-items: center;
    gap: 0.05rem;
}
div.text-day{
    width: 0.24rem;
    height: 0.24rem;
    font-size: 0.14rem;
    font-family: PF-Medium, sans-serif;
    font-weight: bold;
    text-align: center;
    line-height: 0.24rem;
    color: #333333;
    border-radius: 50%;
    border: 0.02rem solid transparent;
    margin-left: 0.05rem;
}

div.text-vice-day{
    flex: 1;
    font-size: 0.14rem;
    font-family: PF-Regular, sans-serif;
    /*color: #999999;*/
}
div.text-work-day, div.text-rest-day{
    width: 0.2rem;

    font-size: 0.14rem;
    font-family: PF-Medium, sans-serif;
    text-align: center;
    margin-right: 0.05rem;
}
div.text-work-day{
    color: #06CE90;
}
div.text-rest-day{
    color: #E13E39;
}

div.row-item-matter{
    width: calc(100% - 0.8rem);
    height: 0.55rem;
    margin-top: -0.56rem;
    margin-left: 0.8rem;
    padding-top: 0.04rem;
    box-sizing: border-box;
}
div.chain-row{
    width: 100%;
    height: 0.24rem;
    font-size: 0;
}

div.item-matter{
    height: 0.24rem;
    padding: 0.01rem 0.05rem;
    box-sizing: border-box;
    display: inline-block;
}
div.text-matter{
    width: 100%;
    height: 0.20rem;
    border-radius: 0.04rem;
    font-size: 0.14rem;
    font-family: PF-Regular, sans-serif;

    color: #333333;
    line-height: 0.20rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
    padding-left: 0.08rem;
}


div.row-scroll{
    width: 100%;
    height: calc(100% - 0.46rem - 0.9rem);

    /*overflow-x: hidden;*/
    overflow-y: auto;
}
div.row-up-fold-hour, div.row-down-fold-hour{
    width: 100%;
    height: 1rem;
    display: flex;
    box-sizing: border-box;
    border-bottom: #EEEEEE solid 0.01rem;
}
div.row-up-fold-hour div.left-hour, div.row-down-fold-hour div.left-hour{
    background: #F6F7F8;
}

div.row-hour-item{
    width: 100%;
    height: 1.55rem;
    display: flex;
    box-sizing: border-box;
    border-bottom: #EEEEEE solid 0.01rem;
}
div.left-hour{
    flex-basis: 0.8rem;
    font-size: 0.12rem;
    font-family: PF-Regular, sans-serif;
    color: rgba(51, 51, 51, 0.5);
    line-height: 0.16rem;
    text-align: center;
}
div.hour-text{

}

div.fold-switch{
    margin-top: 0.5rem;
}

div.item-hour-day{
    flex: 1;
    box-sizing: border-box;
    border-left: #EEEEEE solid 0.01rem;
}
div.fold-matter-text, div.fold-more-text{
    max-width: 2.5rem;
    height: 0.24rem;

    font-family: PF-Regular, sans-serif;
    font-size: 0.14rem;
    color: #333333;
    line-height: 0.24rem;
    text-align: left;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    padding: 0 0.14rem;
    box-sizing: border-box;

}

div.column-items-day{
    width: calc(100% - 0.8rem);
    /*height: calc(1.55rem * 24);*/
    /*margin-top: calc(-1.55rem * 24);*/
    margin-left: 0.8rem;
    position: relative;
    display: flex;
}
div.time-line{
    width: 100%;
    height: 0.01rem;
    z-index: 2;

    display: inline-block;
    vertical-align: top;
    transition: margin-top 0.2s linear;
}
div.time-line-point{
    width: 0.1rem;
    height: 0.1rem;
    background: #E13E39;
    margin-top: -0.05rem;
    border-radius: 50%;

    display: inline-block;
    vertical-align: top;
}
div.hour-text-now{
    width: 0.45rem;
    height: 0.24rem;
    margin-top: -0.12rem;
    margin-left: -0.6rem;
    background: #000000;

    font-family: PF-Regular, sans-serif;
    font-size: 0.12rem;
    color: #FFFFFF;
    line-height: 0.24rem;
    text-align: center;
    border-radius: 0.5rem 0 0.5rem 0.5rem;

    display: inline-block;
    vertical-align: top;
}


div.column-item-day{
    width: calc(100% / 7);
    display: flex;
}


div.matter-item{
    box-sizing: border-box;
    padding: 0.01rem 0.02rem;
    position: relative;

}
div.matter-text{
    width: 100%;
    height: 100%;
    border-radius: 0.04rem;
    font-size: 0.14rem;
    font-family: PF-Regular, sans-serif;
    color: #333333;
    line-height: 0.22rem;

    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
    /*padding-left: 0.08rem;*/
}
</style>